import { environment } from '../../../../../environments';
import { CachedContent } from '../../../../interfaces/cached-content';

/**
 * Sets a fallback title when SEO content is not available
 * @param cacheContent - The cached content containing customer configuration
 * @param document - The document object to update the title
 */
export function setFallbackTitle(cacheContent: CachedContent, $document: Document): void {
  const fallbackTitle = `${cacheContent.cache.config.webAppConfig.name} ${environment.previewMode ? '[PREVIEW]' : ''}`;

  $document.title = fallbackTitle;
}
